<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Brand</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                        <button type="button" class="btn btn-primary" data-toggle="modal" data-original-title="test"
                            data-target="#exampleModal" (click)="open(content)">Add Brand</button>
                        <ng-template #content let-modal>
                            <div class="modal-header">
                                <h5 class="modal-title f-w-600" id="exampleModalLabel">Add Brand</h5>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form class="needs-validation" #brandForm="ngForm" (ngSubmit)="onSubmit(brandForm)">
                                    <div class="form">
                                        <div class="form-group">
                                            <label for="validationCustom01" class="mb-1">Brand Name :</label>
                                            <input class="form-control" id="validationCustom01" type="text" [(ngModel)]="Brand.brand1"
                                                name="Brand">
                                        </div>
                                        <div class="form-group">
                                            <label for="validationCustom01" class="mb-1">Brand fr:</label>
                                            <input class="form-control" id="validationCustom01" type="text" [(ngModel)]="Brand.fr_brand"
                                                name="fr_Brand">
                                        </div>
                                        <div class="form-group">
                                            <label for="validationCustom01" class="mb-1">Brand es :</label>
                                            <input class="form-control" id="validationCustom01" type="text" [(ngModel)]="Brand.es_brand"
                                                name="es_Brand">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button  (click)="onSubmit(brandForm)" class="btn btn-primary">Save</button>
                                <button class="btn btn-secondary" type="button" data-dismiss="modal"
                                    (click)="modal.dismiss('Cross click')">
                                    Close</button>
                            </div>
                        </ng-template>
                    </div>
                    <div id="batchDelete" class="category-table custom-datatable">
                        <div class="table-respon5sive">
                            <ng2-smart-table [settings]="settings" [source]="Source"
                                (editConfirm)="updateRecord($event)" (deleteConfirm)="deleteRecord($event)">
                            </ng2-smart-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>